import moment from "moment";

export const salt = () => {
  // @Returns a 9-character string of random numbers and letters
  // to provide a unique key for repeating elements in a loop
  // eg: o3qfpgfr5
  return Math.random()
    .toString(36)
    .substr(2, 9);
};

export const getSlug = (url, trailingSlash = false) => {
  // @Returns the last segment of the given `url`
  const offset = trailingSlash ? -2 : -1;
  return url.split("/").slice(offset)[0];
};

export const stripTags = input => {
  // @Returns the given `input` without HTML tags
  return input.replace(/<\/?[^>]+(>|$)/g, "");
};

export const stripClass = input => {
  // @Returns the given `input` without class attribute
  return input.replace(/(class=\\")(.*?)"/g, "");
};

export const isTouchDevice = () => {
  // @Returns a Boolean to indicate whether or not a touch device has been detected
  var prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
  var mq = function(query) {
    return window.matchMedia(query).matches;
  };

  // if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
  //   return true;
  // }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
  return mq(query);
};

export const scrollToBottom = el => {
  el.current.scrollTop = el.current.scrollHeight;
};

export const explodedDate = date => {
  date = moment(date, "DD-MM-YYYY");

  const returnValue = {
    year: date.get("year"),
    month: date.get("month") + 1,
    day: date.get("date")
  };

  return returnValue;
};

export const sortByDate = (a, b) => {
  if (a.Date < b.Date) {
    return -1;
  }
  if (a.Date > b.Date) {
    return 1;
  }
  return 0;
};

export const lockScroll = () => {
  document.body.style.top = `-${window.scrollY}px`;
  document.body.style.position = "fixed";
};

export const unlockScroll = () => {
  const scrollY = document.body.style.top;
  document.body.style.position = "";
  document.body.style.top = "";
  const html = document.querySelector("html");
  html.style.scrollBehavior = "auto";
  window.scrollTo({ top: parseInt(scrollY || "0") * -1 });
  html.style.scrollBehavior = "smooth";
};

export const languageContent = () => {
  const language = require(`../languages/${process.env.REACT_APP_LANG ||
    "en-gb"}`).default;
  return language || {};
};

// export const updateHrefLangs = links => {
//   const head = document.querySelector("head");
//   const altLinks = document.querySelectorAll('link[rel="alternate"]');
//   for (let i = altLinks.length - 1; i >= 0; i--) {
//     head.removeChild(altLinks[i]);
//   }
//   if (links) {
//     links.forEach(link => {
//       const newLink = document.createElement("link");
//       newLink.rel = "alternate";
//       newLink.href = link.link;
//       newLink.hreflang = link.lang;
//       head.insertBefore(newLink, head.firstChild);
//     });
//   }
// };
